export enum NewAlertType {
    Success,
    Error,
    Info,
    Warning
}